import { blue, darkOrange, orange, white } from '@/theme/colors'
import { fontBody, fontDisplay } from '@/theme/fonts'
import { breakpoints, radii } from '@/theme/tokens'
import styled from 'styled-components'

export const Band = styled.section`
	margin-top: 48px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 24px;
	flex-wrap: wrap;
	padding: 30px 34px;
	background: ${blue};
	border-radius: ${radii.band};
	color: ${white};

	/* Phone: a centered, stacked CTA card rather than the wide desktop band. */
	@media (max-width: ${breakpoints.phone}px) {
		margin-top: 24px;
		flex-direction: column;
		align-items: center;
		text-align: center;
		gap: 16px;
		padding: 22px 20px;
	}
`

/* Explicit white: the GlobalStyle h2/p element rules paint dark otherwise. */
export const BandTitle = styled.h2`
	font-family: ${fontDisplay};
	font-weight: 900;
	font-size: 24px;
	letter-spacing: -0.01em;
	color: ${white};
	margin: 0;
`

export const BandSub = styled.p`
	font-family: ${fontBody};
	font-size: 14.5px;
	color: ${white};
	opacity: 0.85;
	margin: 6px 0 0;
	max-width: 520px;
	text-wrap: pretty;
`

export const BandActions = styled.div`
	display: flex;
	gap: 10px;
	flex-shrink: 0;
	flex-wrap: wrap;

	/* Phone: full-width stacked buttons under the copy. */
	@media (max-width: ${breakpoints.phone}px) {
		width: 100%;
		flex-direction: column;
		gap: 10px;
	}
`

export const OutlineButton = styled.a`
	font-family: ${fontDisplay};
	font-weight: 700;
	font-size: 14.5px;
	color: ${white};
	background: transparent;
	border: 1.5px solid rgba(255, 255, 255, 0.5);
	border-radius: 14px;
	padding: 10px 20px;
	text-decoration: none;
	cursor: pointer;
	white-space: nowrap;
	transition: background 0.2s ease-out;

	&:hover {
		background: rgba(255, 255, 255, 0.1);
	}

	@media (prefers-reduced-motion: reduce) {
		transition: none;
	}

	@media (max-width: ${breakpoints.phone}px) {
		width: 100%;
		min-height: 44px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		border-radius: 12px;
	}
`

export const OrangeButton = styled.a`
	font-family: ${fontDisplay};
	font-weight: 700;
	font-size: 14.5px;
	color: ${white};
	background: ${orange};
	border: none;
	border-radius: 14px;
	padding: 11px 20px;
	text-decoration: none;
	cursor: pointer;
	white-space: nowrap;
	transition:
		background 0.2s ease-out,
		transform 0.12s ease-out;

	&:hover {
		background: ${darkOrange};
	}

	&:active {
		transform: scale(0.97);
	}

	@media (prefers-reduced-motion: reduce) {
		transition: none;
	}

	@media (max-width: ${breakpoints.phone}px) {
		width: 100%;
		min-height: 44px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		border-radius: 12px;
	}
`
